package com.example.mystybag.sharedmodels.project.requestModels.merchant

import kotlinx.serialization.Serializable

@Serializable
data class SignatoryItem(
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val dialCode: String
)
